import { useEffect, useState } from 'react';
import styles from '@components/Message/MessageTimeBar.styles';
type PropsType = {
  displayTime: number;
};
const MessageTimeBar = ({
  displayTime
}: PropsType) => {
  const [timeBarProgress, setTimeBarProgress] = useState(100);
  useEffect(() => {
    const displayTimeInSeconds = displayTime / 1000;
    const procentagePart = 100 / displayTimeInSeconds;
    setTimeBarProgress(100 - procentagePart);
    const interval = setInterval(() => {
      setTimeBarProgress(prevProgress => {
        const newProgress = prevProgress - procentagePart;
        if (newProgress <= 0) {
          clearInterval(interval);
          return 0;
        }
        return newProgress;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  return <div sx={styles.container(timeBarProgress)} />;
};
export default MessageTimeBar;